// Matches Sentinel's own time-range picker (Last 24 hours / 48 hours / 7 days /
// 14 days / 30 days), with 60d/90d/All kept on afterward as Kloudsecure-specific
// extensions beyond what Sentinel's dropdown offers.
export type DashboardTimeRange = '24h' | '48h' | '7d' | '14d' | '30d' | '60d' | '90d' | 'all';

export const DASHBOARD_TIME_RANGES: readonly DashboardTimeRange[] = [
  '24h',
  '48h',
  '7d',
  '14d',
  '30d',
  '60d',
  '90d',
  'all',
] as const;

const VALID_RANGES = new Set<string>(DASHBOARD_TIME_RANGES);

export function normalizeDashboardTimeRange(value: string | null | undefined): DashboardTimeRange {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (VALID_RANGES.has(normalized)) return normalized as DashboardTimeRange;

  // Backward compatibility with older values stored in localStorage —
  // 1h/4h/8h/12h predate the Sentinel-matching picker and all collapse to
  // 24h, the shortest window now offered.
  if (normalized === '1h' || normalized === '4h' || normalized === '8h' || normalized === '12h') return '24h';
  if (normalized === '1' || normalized === '1d') return '24h';
  if (normalized === '7') return '7d';
  if (normalized === '30') return '30d';
  if (normalized === '60') return '60d';
  if (normalized === '90') return '90d';

  return '24h';
}

export function dashboardTimeRangeLabel(value: DashboardTimeRange): string {
  if (value === 'all') return 'All';
  return value;
}

export function dashboardTimeRangeDescription(value: DashboardTimeRange): string {
  if (value === 'all') return 'All time';
  return `Last ${value}`;
}
